import {
  Typography,
  Button,
  Link,
  Box,
} from '@mui/material';
import {
  SignInContainer,
  SignInCard,
  SignInStack,
} from './StyledComponents';
import AppTheme from '../../shared-theme/AppTheme';
import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';
import TytoLogo from '../../images/owl.svg';

export default function SignIn() {
  return (
    <>
      <AppTheme>
        <SignInStack>
          <ColorModeIconDropdown
            sx={{ position: 'fixed', top: '1rem', right: '1rem' }}
          />
          <SignInContainer>
            <SignInCard variant="outlined">
              <Typography
                component="p"
                sx={{
                  color: '#1F4D83',
                  fontSize: '1.25rem',
                  fontWeight: 500,
                  marginBottom: '-8px',
                }}
              >
                Welcome to
              </Typography>
              <Typography
                component="h1"
                sx={{
                  color: '#1F4D83',
                  fontSize: '2.5rem',
                  fontWeight: 700,
                  letterSpacing: '0.1em',
                  marginBottom: '16px',
                }}
              >
                ATHENA
              </Typography>
             
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="secondary"
                sx={{
                  textTransform: 'none',
                  padding: '10px 24px',
                }}
                onClick={() => window.location.href='/api/tytoauth'}
              >
                Login
              </Button>
              {/* <Link
                href="#"
                sx={{
                  color: '#1a4480',
                  textDecoration: 'underline',
                  fontSize: '0.875rem',
                  marginTop: '8px',
                  cursor: 'pointer',
                }}
                onClick={(e) => e.preventDefault()}
              >
                Forgot Password?
              </Link> */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginTop: '24px',
                  gap: '8px',
                }}
              >
                <Typography
                  sx={{
                    color: '#666',
                    fontSize: '0.875rem',
                  }}
                >
                  Powered by Tyto Athene
                </Typography>
                <img
                  src={TytoLogo}
                  alt="Tyto Athene"
                  style={{ width: '40px', height: '40px' }}
                />
              </Box>
            </SignInCard>
          </SignInContainer>
        </SignInStack>
      </AppTheme>
    </>
  );
}
